import { singleton } from "tsyringe";
import type { SimulatorProduct, SimulatorRequest, SimulatorResult } from "common/types/Simulator";
import BaseApi from "./BaseApi";

@singleton()
export default class SimulatorApi extends BaseApi {
	public products() {
		return this.getRequest<SimulatorProduct[]>(`${this.apiUrl}/simulator/products`);
	}
	public calculate(request: SimulatorRequest) {
		return this.postRequest<SimulatorResult>(`${this.apiUrl}/simulator/calculate`, { ...request });
	}
}
